import Vue from 'vue';

const bus = new Vue({
  methods: {
    loginSuccess() {
      this.$emit('login:success');
    },
    refreshFeed() {
      this.$emit('feed:refresh');
    },
    refreshUnreadedNo() {
      this.$emit('get:unreaded');
    },
    refreshPinboardList() {
      this.$emit('get:pinboards');
    },
    pinboardNotFound() {
      this.$emit('pinboard-not-found');
    },
    refreshCurrentMessage(id, message) {
      this.$emit('message:refresh', id, message);
    },
  },
});

export default bus;



// WEBPACK FOOTER //
// ./src/event-bus.js